import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import OkModal from '@/shared/components/OkModal';
import messages from './trainingMessages';
import classNames from 'classnames';
import Checkbox from '@/shared/components/input/Checkbox';
import FormattedListValue, {
  listItemMsg,
  formatListValue,
} from '@/shared/components/FormattedListValue';

class EmployeeTrainingModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    training: PropTypes.object.isRequired,
  };

  static defaultProps = {
    show: false,
  };

  render() {
    const { show, onClose, intl, training } = this.props;
    const title = intl.formatMessage(messages.Training);

    return (
      <OkModal
        show
        title={title}
        okClassName="btn btn-default"
        onClose={onClose}
        onSave={onClose}
        okLabel={intl.formatMessage(messages.Close)}
      >
        <form className="form-horizontal form-labels-left container-fluid">
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.Name} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">{training.trainingName}</p>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.ExpectedTrainingHours} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">{training.trainingDurationHours}</p>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.RegisteredTrainingHours} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">
                {training.trainingEmployeeDurationMinutes.minuteToTime()}
              </p>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.Type} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">
                {intl.formatMessage(listItemMsg('trainingType', training.type))}
              </p>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.Status} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">
                {intl.formatMessage(listItemMsg('trainingStatus', training.trainingStatus))}
              </p>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.CompletedDate} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">
                {training.completedDate ? intl.formatDate(training.completedDate) : ''}
              </p>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.StartDate} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">{intl.formatDate(training.trainingStartDate)}</p>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.EndDate} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">{intl.formatDate(training.trainingEndDate)}</p>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.Mandatory} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">
                <Checkbox value={training.mandatory} onClick={() => {}} disabled />
              </p>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.CertificateRequired} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">
                <Checkbox value={training.certificateRequired} onClick={() => {}} disabled />
              </p>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-4">
              <FormattedMessage {...messages.Description} />
            </label>
            <div className="col-sm-8">
              <p className="form-control-static">{training.description}</p>
            </div>
          </div>
        </form>
      </OkModal>
    );
  }
}

export default injectIntl(EmployeeTrainingModal);
